import anime from "animejs";
import {isMobile} from "mobile-device-detect";

export const animations = new Map();

export const loadAnimation = url => {
    if (animations.get(url)) {
        return Promise.resolve(animations.get(url));
    }

    const fixedURL = isMobile ?
        url.replace(/([\w-/]+\/)([\w-/]+\.json)/, `$1mobile-$2`) :
        url;

    return fetch(fixedURL)
        .then(res => res.json())
        .then(json => {
            animations.set(url, json);

            return json;
        });
};

export const loadIntroAnimations = () => Promise.all([
    loadAnimation(`/animations/intro/intro-loading.json`),
    loadAnimation(`/animations/intro/intro-q1-loop.json`),
    loadAnimation(`/animations/intro/intro-q1.json`)
]);

export const loadQ1Animations = () => Promise.all([
    loadAnimation(`/animations/family/family-q1-q2.json`),
    loadAnimation(`/animations/family/family-q2-loop.json`),
    loadAnimation(`/animations/disability/disability-q1-q2.json`),
    loadAnimation(`/animations/empty_nester/empty_nester-q1-q2.json`),
    loadAnimation(`/animations/empty_nester/empty_nester-q2-loop.json`),
    loadAnimation(`/animations/retirement/retirement-q1-q2.json`),
    loadAnimation(`/animations/retirement/retirement-q2-loop.json`)
]);

const nameMap = {
    family : [
        `/animations/family/family-q2-loop.json`,
        `/animations/family/family-q2-q3.json`,
        `/animations/family/family-q3-loop.json`,
        `/animations/family/family-q3-q4.json`,
        `/animations/family/family-q4-results.json`
    ],
    empty_nester : [
        `/animations/empty_nester/empty_nester-q2-loop.json`,
        `/animations/empty_nester/empty_nester-q2-q3.json`,
        `/animations/empty_nester/empty_nester-q3-loop.json`,
        `/animations/empty_nester/empty_nester-q3-q4.json`,
        `/animations/empty_nester/empty_nester-q4-results.json`
    ],
    retirement : [
        `/animations/retirement/retirement-q2-loop.json`,
        `/animations/retirement/retirement-q2-q3.json`,
        `/animations/retirement/retirement-q3-loop.json`,
        `/animations/retirement/retirement-q3-q4.json`,
        `/animations/retirement/retirement-q4-loop.json`,
        `/animations/retirement/retirement-q4-results.json`
    ],
    disability : [
        `/animations/disability/disability-q2-q3.json`,
        `/animations/disability/disability-q3-loop.json`,
        `/animations/disability/disability-q3-q4.json`,
        `/animations/disability/disability-q4-results.json`
    ]
};

// family, empty_nester, retirement, disability
export const loadRemainingAnimations = ltm =>
    Promise.all(nameMap[ltm].map(loadAnimation));

export const playQ1Animation = (setCurrentAnimation, ltm) => {
    let animationData = {
        path     : ``,
        autoplay : true,
        loop     : {
            path : ``
        }
    };

    switch (ltm) {
    case `family` :
        animationData.path      = `/animations/family/family-q1-q2.json`;
        animationData.loop.path = `/animations/family/family-q2-loop.json`;
        break;
    case `disability` :
        animationData.path = `/animations/disability/disability-q1-q2.json`;
        animationData.loop = null;
        break;
    case `empty_nester` :
        animationData.path      = `/animations/empty_nester/empty_nester-q1-q2.json`;
        animationData.loop.path = `/animations/empty_nester/empty_nester-q2-loop.json`;
        break;
    case `retirement` :
        animationData.path      = `/animations/retirement/retirement-q1-q2.json`;
        animationData.loop.path = `/animations/retirement/retirement-q2-loop.json`;
        break;
    default :
        throw new Error(`Bad LTM ${ltm}`);
    }

    setCurrentAnimation(animationData);
};

export const playQ2Animation = (setCurrentAnimation, ltm) => {
    let animationData = {
        path     : ``,
        autoplay : true,
        loop     : {
            path : ``
        }
    };

    switch (ltm) {
    case `family` :
        animationData.path      = `/animations/family/family-q2-q3.json`;
        animationData.loop.path = `/animations/family/family-q3-loop.json`;
        break;
    case `disability` :
        animationData.path      = `/animations/disability/disability-q2-q3.json`;
        animationData.loop.path = `/animations/disability/disability-q3-loop.json`;
        break;
    case `empty_nester` :
        animationData.path      = `/animations/empty_nester/empty_nester-q2-q3.json`;
        animationData.loop.path = `/animations/empty_nester/empty_nester-q3-loop.json`;
        break;
    case `retirement` :
        animationData.path      = `/animations/retirement/retirement-q2-q3.json`;
        animationData.loop.path = `/animations/retirement/retirement-q3-loop.json`;
        break;
    default :
        throw new Error(`Bad LTM ${ltm}`);
    }

    setCurrentAnimation(animationData);
};

export const playQ3Animation = (setCurrentAnimation, ltm) => {
    let animationData = {
        path     : ``,
        autoplay : true,
        loop     : {
            path : ``
        }
    };

    switch (ltm) {
    case `family` :
        animationData.path = `/animations/family/family-q3-q4.json`;
        animationData.loop = null;
        break;
    case `disability` :
        animationData.path = `/animations/disability/disability-q3-q4.json`;
        animationData.loop = null;
        break;
    case `empty_nester` :
        animationData.path = `/animations/empty_nester/empty_nester-q3-q4.json`;
        animationData.loop = null;
        break;
    case `retirement` :
        animationData.path      = `/animations/retirement/retirement-q3-q4.json`;
        animationData.loop.path = `/animations/retirement/retirement-q4-loop.json`;
        break;
    default :
        throw new Error(`Bad LTM ${ltm}`);
    }

    setCurrentAnimation(animationData);
};

export const playQ4Animation = (setCurrentAnimation, ltm) => {
    let animationData = {
        path     : ``,
        autoplay : true,
        loop     : {
            path : ``
        }
    };

    switch (ltm) {
    case `family` :
        animationData.path = `/animations/family/family-q4-results.json`;
        animationData.loop = null;
        break;
    case `disability` :
        animationData.path = `/animations/disability/disability-q4-results.json`;
        animationData.loop = null;
        break;
    case `empty_nester` :
        animationData.path = `/animations/empty_nester/empty_nester-q4-results.json`;
        animationData.loop = null;
        break;
    case `retirement` :
        animationData.path = `/animations/retirement/retirement-q4-results.json`;
        animationData.loop = null;
        break;
    default :
        throw new Error(`Bad LTM ${ltm}`);
    }

    setCurrentAnimation(animationData);
};

export const withTransition = props => {
    const els = document.querySelectorAll(props.targets);

    if (els && els.length) {
        els.forEach(el => el.classList.add(`in-transition`));
    } else {
        return console.warn(`cannot animate ${props.targets}, missing DOM element`);
    }

    const ref = anime({
        easing   : `linear`,
        complete : anim => {
            els.forEach(el => el.classList.remove(`in-transition`));
            if (typeof props.complete === `function`) {
                props.complete(anim);
            }
        },
        ...props
    });

    return () => {
        ref.pause();
        anime.remove(ref);
    };
};
